module.exports = __webpack_public_path__ + "img/recruit-p-500.26a1747c.jpeg";